
import { Component, Vue } from "vue-property-decorator";
import Sidebar from "@/components/navigations/sidebar.vue";
import Cta from "@/components/buttons/Button.vue";

@Component({
  components: {
    Sidebar,
    Cta,
  },
})
export default class Declenchements extends Vue {}
